const initialState = {
    sections: [],
    loading: false,
    error: null,
};

const businessInsightsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'business/get-insights/pending':
            return { ...state, loading: true, error: null };
        case 'business/get-insights/fulfilled':
            return { ...state, loading: false, sections: action.payload.data };
        case 'business/get-insights/rejected':
            return { ...state, loading: false, error: "No business insights data found." };
        default:
            return state;
    }
};

export default businessInsightsReducer;
